import React from 'react';
import { bool, array, func, number } from 'prop-types';
import Button from '../../shared/Button';
import PhotoGrid from './PhotoGrid';
import { ServerCommunicationUtil } from '../../../utils/server_communication_util';
import { photosSection } from './styles/styles.module.scss';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const PhotoSection = ({ isEditing, openTrailFormModal, mapId, updateMapPhotos, canEdit, mapPhotos }) => {
  const addMarkersAndUpload = ({ detail }) => {
    updateMapPhotos(detail);
    // TODO add markers
  };

  const openAddPhotoModal = () => {
    const url = `/api/alltrails/maps/${mapId}/photos?key=${ServerCommunicationUtil.apiKey}`;
    openTrailFormModal('photos', { url, onPhotosAdd: addMarkersAndUpload });
  };

  const hasMapPhotos = mapPhotos.length > 0;

  const showAddButton = canEdit || isEditing;

  return (
    <div className={photosSection}>
      {hasMapPhotos && <PhotoGrid mapPhotos={mapPhotos} mapId={mapId} />}
      {showAddButton && (
        <Button onClick={openAddPhotoModal} variant="secondary">
          {StringConstantsMixin.strings.MAP_CREATOR.ADD_NEW_PHOTOS}
        </Button>
      )}
    </div>
  );
};

export default PhotoSection;

PhotoSection.propTypes = {
  isEditing: bool.isRequired,
  mapPhotos: array.isRequired,
  openTrailFormModal: func.isRequired,
  mapId: number.isRequired,
  updateMapPhotos: func.isRequired
};
